import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProviderList from './ProviderList';
import ProviderForm from './ProviderForm';

const Providers = () => {
  return (
    <Routes>
      <Route index element={<ProviderList />} />
      <Route path="new" element={<ProviderForm />} />
      <Route path=":id/edit" element={<ProviderForm />} />
    </Routes>
  );
};

export default Providers;

